export default __webpack_public_path__ + "static/media/flips_2025_order.dacb3e4a.png";